import type { ReactElement } from "react";

import { useTT } from "../useTT.ts";
import { ErrorNumbers } from "./ErrorNumbers.tsx";
import { ErrorPageContent } from "./ErrorPageContent.tsx";

export function Error500Content(): ReactElement {
  const { tt } = useTT();

  return (
    <ErrorPageContent
      graphic={<ErrorNumbers>500</ErrorNumbers>}
      title={tt("errorPages.Error500.title")}
      description={tt("errorPages.Error500.description")}
      buttonTitle={tt("errorPages.Error500.buttonTitle")}
      onButtonClick={() => (window.location.href = "/")}
    />
  );
}
